<template>
  <div>
    <v-row
      :class="{ 'pl-2': true, 'pr-4': true, 'cursor-pointer': true }"
      @click="showQuestions = !showQuestions"
    >
      <v-col>
        <v-card-title>
          {{ category.name }}
          <span class="subtitle-1 lighttext--text my-auto pl-4">
            {{ category.questions.filter(x => x.isEnabled).length }}
            of {{ category.questions.length }} Enabled
          </span>
        </v-card-title>
        <v-card-subtitle>
          {{ category.description }}
        </v-card-subtitle>
      </v-col>
      <v-spacer class="limited-spacer"> </v-spacer>
      <v-col cols="auto" class="my-auto">
        <v-switch
          v-model="category.isEnabled"
          color="success"
          hide-details
          class="my-0"
          @click.native.stop
          @change="$emit('toggle', $event)"
        ></v-switch>
      </v-col>
      <v-col cols="auto" class="my-auto">
        <v-menu absolute v-if="category.companyId != null">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon>
                more_vert
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="$emit('edit')">
              <v-list-item-icon>
                <v-icon>edit</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$emit('delete')">
              <v-list-item-icon>
                <v-icon>delete</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-else icon @click="showInfoOverlay">
          <v-icon color="grey lighten-1">
            more_vert
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <template v-if="showQuestions">
      <question-list
        :category="category"
        :featureId="featureId"
      ></question-list>
      <v-divider></v-divider>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import QuestionList from "@/components/questions/QuestionList";
export default {
  components: { QuestionList },
  name: "CategoryCard",
  props: {
    category: { type: Object },
    manageLink: { type: String },
    featureId: { type: Number }
  },
  data: () => ({ showQuestions: false }),
  computed: {
    ...mapGetters({})
  },
  created() {},
  methods: {
    showInfoOverlay() {
      this.$root.$alert(
        "Category Locked",
        "This question category set was created by CoreCounts and can not be renamed or deleted. You may disable certain questions from being asked as well as add new questions to this category set by clicking on the manage questions button"
      );
    }
  }
};
</script>
